import { store } from '../store.index'
import { API_ROOT, INBOX_API_ROOT } from 'Config'
import axios from 'axios'
import { getFbTrackingData } from './helper'

export default ({
  requestType = 'get',
  center = localStorage.getItem('selected_center_id'),
  url,
  data = {},
  params = {}
}) => {
  let requestUrl = `${API_ROOT}/api/embed/${url}`
  const rwgToken = localStorage.getItem('rwg_token')
  // Forward fbp/fbc/external_id to API for Conversions API match quality
  const { fbp, fbc, externalId } = getFbTrackingData()
  const customerKey = localStorage.getItem('customerkey')
  let axiosConfig = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // The API treats `Bearer null` as an invalid token, so guests must send
      // no Authorization header at all.
      ...(customerKey ? { Authorization: 'Bearer ' + customerKey } : {}),
      'x-aws-waf-token': localStorage.getItem('aws-waf-token'),
      'x-rwg-token': rwgToken || '',
      ...(fbp ? { 'X-FB-Browser-Id': fbp } : {}),
      ...(fbc ? { 'X-FB-Click-Id': fbc } : {}),
      ...(externalId ? { 'X-FB-External-Id': externalId } : {})
    }
  }

  axiosConfig.params = {
    region_id: data.region_id ?? localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    center_id: data.center_id ?? center,
    ...params
  }

  if (requestType === 'post') {
    if (data instanceof FormData)
      axiosConfig.headers['Content-Type'] = 'multipart/form-data'
    //since upgrading to axios 1.6.7 we check data is in the form of formData
    return axios[requestType](requestUrl, data, axiosConfig)
  }

  return axios[requestType](requestUrl, axiosConfig)
}

/**
 *
 * @param {Object} Label (key, value)
 * @returns {String} Label Text
 */
export const overrideLabel = ({ key, value, capitalize = false }) => {
  const clientSettings = JSON.parse(localStorage.getItem('clientSettings'))
  const label = clientSettings?.[key] ?? value ?? ''
  return capitalize ? label.charAt(0).toUpperCase() + label.slice(1) : label
}

/**
 * Inbox API client for communication endpoints
 */
export const inboxClient = ({
  requestType = 'get',
  center = localStorage.getItem('selected_center_id'),
  url,
  data = {}
}) => {
  let requestUrl = `${INBOX_API_ROOT}/api/v1/inbox/${url}`
  let axiosConfig = {
    headers: {}
  }

  axiosConfig.params = {}

  if (requestType === 'post') {
    if (data instanceof FormData)
      axiosConfig.headers['Content-Type'] = 'multipart/form-data'
    return axios[requestType](requestUrl, data, axiosConfig)
  }

  return axios[requestType](requestUrl, axiosConfig)
}
